import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorHandlerService } from '@y42/error-handling';
import { FeatureAggregationService } from '@y42/feature';
import { Y42FeatureTypeToRoute, Y42RouterService } from '@y42/feature/routing';

export interface OrchestrationRunDetailsDialogData {
  runId: string;
}

@Component({
  selector: 'y42-orchestration-run-details-dialog',
  templateUrl: './orchestration-run-details-dialog.component.html',
  styleUrls: ['./orchestration-run-details-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationRunDetailsDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: OrchestrationRunDetailsDialogData,
    private readonly dialogRef: MatDialogRef<OrchestrationRunDetailsDialogComponent>,
    private readonly featureAggregationService: FeatureAggregationService,
    private readonly errorHandlerService: ErrorHandlerService,
    private readonly routerService: Y42RouterService,
  ) {}

  onRedirectToAsset(path: string) {
    const feature = this.featureAggregationService.getServiceDefinitionByPath(path);
    if (!feature) {
      this.errorHandlerService.error(
        `[OrchestrationRunDetailsDialogComponent.onRedirectToAsset]: No feature found for ${path}`,
        {
          toast: `No feature found for ${path}`,
        },
      );
      return;
    }

    const parentName = path.split('/').at(-2);
    if (!parentName) {
      this.errorHandlerService.error(
        `[OrchestrationRunDetailsDialogComponent.onRedirectToAsset]: Parent name cannot be undefined in ${path}`,
        {
          toast: `Parent name cannot be undefined in ${path}`,
        },
      );
      return;
    }

    this.routerService.navigateToDetail(Y42FeatureTypeToRoute[feature.featureType], parentName);
    this.dialogRef.close();
  }
}
